import { MessageService } from './../../../services/message.service';
import { DisboAccount } from './../../../data/DisboAccount';
import { CustomerAccount } from 'src/app/data/CustomerAccount';
import { Identity } from './../../../Identity';
import { EntitlementService } from 'src/app/services/entitlement.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { VisitorCardService } from 'src/app/services/visitor-card.service';
import { VisitorCard } from 'src/app/data/VisitorCard';
import { VisitorCardStub } from 'src/app/data/VisitorCardStub';
import { TransferSummary } from 'src/app/data/TransferSummary';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-visitor-card-adjustments',
  templateUrl: './visitor-card-adjustments.component.html',
  styleUrls: ['./visitor-card-adjustments.component.css']
})
export class VisitorCardAdjustmentsComponent implements OnInit {
  @ViewChild('xferForm', { static: false }) xferForm: NgForm;
  @ViewChild('xferAmount', { static: false }) xferAmount: ElementRef;

  identity: Identity;
  visitorCard: VisitorCard;
  visitorCardStub: VisitorCardStub;
  recentVisitorCards: VisitorCardStub[];
  customerAccount: CustomerAccount;
  disboAccounts: DisboAccount[];
  transferSummary: TransferSummary = null;
  debitCheckCircle = 'fa fa-check-circle';
  creditCheckCircle = '';
  dColor = 'adj-nc1';
  cColor = 'adj-nc2';
  dArrow = 'redBackGround';
  cArrow = 'grayBackGround';
  toggleSourceDestination = false;
  xferAmt: number = null;
  actionSuccessFail = 'actionSucess';
  circleCheck = 'fa fa-check-circle fa-2x';
  actionCircle = 'actionCircle';
  actionType = 'D';
  disboAccount: number = null;
  transferStarted = false;

  constructor(
    private visitorCardService: VisitorCardService,
    private entitlementService: EntitlementService,
    private messageService: MessageService,
    private router: Router
  ) {}

  ngOnInit() {
    const card = this.visitorCardService.getSelectedVisitorCardStub();

    this.refreshCardData(card);

    this.visitorCardService.getDisboAccounts().subscribe((data) => {
      this.disboAccounts = data;
      this.disboAccount = this.disboAccounts[0].account;
    });

    this.recentVisitorCards =
      this.visitorCardService.getRecentVisitorCardStubs();

    const that = this;
    this.visitorCardService.visitorCardStubSelected.subscribe((data) => {
      that.refreshCardData(data);
    });
  }

  refreshCardData(card: VisitorCardStub) {
    if (card) {
      this.visitorCardStub = card;
      this.visitorCardService
        .getVisitorCardDetails(card.cardSeq)
        .subscribe((data) => {
          this.identity = data.identity;
          this.visitorCard = data.card;
          this.customerAccount = data.customerAccount;
        });
    } else {
      this.router.navigate(['/visitorCards']);
    }
  }

  creditDebit(actionType: string) {
    this.actionType = actionType;
    if (actionType === 'D') {
      this.debitCheckCircle = 'fa fa-check-circle';
      this.creditCheckCircle = '';
      this.dColor = 'adj-nc1';
      this.cColor = 'adj-nc2';
      this.dArrow = 'redBackGround';
      this.cArrow = 'grayBackGround';
      this.toggleSourceDestination = false;
    } else {
      this.creditCheckCircle = 'fa fa-check-circle';
      this.debitCheckCircle = '';
      this.cColor = 'adj-nc1';
      this.dColor = 'adj-nc2';
      this.cArrow = 'greenBackGround';
      this.dArrow = 'grayBackGround';
      this.toggleSourceDestination = true;
    }
  }

  balanceTransfer() {
    const that = this;
    this.visitorCardService
      .balanceTransfer(
        '' + this.visitorCard.chipAccount,
        '' + this.disboAccount,
        '' + this.xferAmt,
        this.toggleSourceDestination
      )
      .subscribe(
        (data) => {
          that.transferSummary = data;
          that.xferAmt = null;
          that.transferStarted = false;
          that.messageService.success('Balance Adjusted Successfully');
          that.xferForm.form.controls.xferAmt.reset();
        },
        (error) => {
          this.cancel();
          that.messageService.error(error.error);
        }
      );
  }

  startTransfer() {
    if (this.xferAmt == null || this.xferAmt <= 0 || !this.xferForm.valid) {
      this.xferAmount.nativeElement.focus();
      this.xferAmount.nativeElement.blur();
      return;
    }
    this.transferStarted = true;
  }

  cancel() {
    this.transferStarted = false;
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }
}
